module.exports = __webpack_public_path__ + "static/flexprint-main-banner-image-89b21b9caa4cf95982fe98d29e4d6fdc.png";